import { staticEntityReducerTemplate } from '../reducerUtils';

export default staticEntityReducerTemplate('provinces');



// WEBPACK FOOTER //
// ./src/reducers/entities/provincesReducer.js